import { useState } from 'react';
import styled from 'styled-components';

// Styled component for the wrapper
const Wrapper = styled.section`
  direction: rtl;
  /* min-height: 100vh; */
  display: grid;
  align-items: center;
  .logo {
    display: block;
    margin: 0 auto;
    margin-bottom: 1.38rem;
  }
  .form {
    /* max-width: 400px; */
    border-top: 5px solid var(--primary-500);
  }
  h4 {
    text-align: center;
    margin-bottom: 1.38rem;
  }
  p {
    margin-top: 1rem;
    text-align: center;
    line-height: 1.5;
  }
  .btn {
    margin-top: 1rem;
  }
  .member-btn {
    color: var(--primary-500);
    letter-spacing: var(--letter-spacing);
    margin-left: 0.25rem;
  }
`;

const OfficeBuildingFloors = () => {
 const floors = [];
  // Define your initial state here
  const initialState = {
    selectedFloor: '', // Initially no floor is selected
  };

  const [formData, setFormData] = useState(initialState);

  const handleFloorChange = (selectedFloor) => {
    // Update the selected floor when the user makes a selection
    setFormData({
      ...formData,
      selectedFloor,
    });
  };

  // Your form input change and submit handlers can be defined here

  return (
    <Wrapper className='full-page'>
      <div className='form'>
        <h4 className='form-title'>
          {formData.selectedFloor !== ''
            ? 'Edit Building Details'
            : 'Add a New Building'}
        </h4>
        {/* Add your form inputs and other components here */}
        {/* For example, you can add a dropdown for selecting a floor */}
        <div className='form-center'>
          <label>Select a Floor:</label>
          <select
            name='selectedFloor'
            value={formData.selectedFloor}
            onChange={(e) => handleFloorChange(e.target.value)}
          >
            <option value=''>Select a floor</option>
            {/* Map over your floors array and create options */}
            {floors.map((floor) => (
              <option key={floor.floorNumber} value={floor.floorNumber}>
                {floor.floorName}
              </option>
            ))}
          </select>
        </div>
        {/* Add other form inputs and buttons here */}
      </div>
      {/* Render the list of businesses based on the selected floor */}
      {formData.selectedFloor && (
        <div className='business-list'>
          {/* Map over the businesses of the selected floor and display them */}
          {floors.find((floor) => floor.floorNumber === formData.selectedFloor)
            ?.businesses.map((business, index) => (
              <div key={index} className='business-item'>
                <img src={business.logoPath} alt={business.name} />
                <p>{business.name}</p>
                <p>Direction: {business.direction}</p>
              </div>
            ))}
        </div>
      )}
    </Wrapper>
  );
};

export default OfficeBuildingFloors;
